import styled from 'styled-components'

export interface IAvatarPhotoStyledProps {
  $photoUrl?: string
}

export const AvatarPhotoStyled = styled.div<IAvatarPhotoStyledProps>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  background-image: ${(props) =>
    props.$photoUrl ? `url("${encodeURI(props.$photoUrl)}")` : 'none'};
  background-size: cover;
  background-position: center;
`

AvatarPhotoStyled.displayName = 'AvatarPhotoStyled'
